export const industryList = [
  { label: 'Select an industry...', value: '' },
  { label: 'HVAC', value: 'HVAC' },
  { label: 'Plumbing', value: 'Plumbing' },
  { label: 'Electrical', value: 'Electrical' },
  { label: 'Garage Door', value: 'Garage Door' },
  { label: 'Chimney Sweep', value: 'Chimney Sweep and Hearth' },
  { label: 'Water Treatment', value: 'Water Treatment' },
  { label: 'Pool & Spa', value: 'Pool/Spa' },
  { label: 'Irrigation', value: 'Irrigation' },
  { label: 'Landscaping', value: 'Landscaping' },
  { label: 'Lawn Care Services', value: 'Lawn Care Services' },
  { label: 'Septic', value: 'Septic' },
  { label: 'Other', value: 'Other' },
];

export const otherIndustryList = [
  { label: 'Select from other industries...', value: '' },
  { label: 'Appliance Repair', value: 'Appliance Repair' },
  { label: 'Building Inspection', value: 'Building Inspection' },
  { label: 'Carpet Cleaning', value: 'Carpet Cleaning' },
  { label: 'Cleaning / Maid Services', value: 'Cleaning / Maid Services' },
  { label: 'Commercial Food Equipment Service', value: 'Commercial Food Equipment Service' },
  { label: 'Restaurant Equipment Service', value: 'Restaurant Equipment Service' },
  { label: 'Construction', value: 'Construction' },
  { label: 'Duct Cleaning', value: 'Duct Cleaning' },
  { label: 'Drywall & Insulation', value: 'Drywall & Insulation' },
  { label: 'Elevator & Escalator', value: 'Elevator & Escalator' },
  { label: 'Fencing', value: 'Fencing' },
  { label: 'Fire Related Services', value: 'Fire Related Services' },
  { label: 'Flooring/Tile', value: 'Flooring/Tile' },
  { label: 'Glass Installation', value: 'Glass Installation' },
  { label: 'Gutter Services', value: 'Gutter Services' },
  { label: 'Handyman', value: 'Handyman' },
  { label: 'Janitorial Services', value: 'Janitorial Services' },
  { label: 'Locksmith', value: 'Locksmith' },
  { label: 'Moving', value: 'Moving' },
  { label: 'Painting', value: 'Painting' },
  { label: 'Paving', value: 'Paving' },
  { label: 'Pest Control', value: 'Pest Control' },
  { label: 'Pressure Washers', value: 'Pressure Washers' },
  { label: 'Restoration', value: 'Restoration' },
  { label: 'Roofing/Siding', value: 'Roofing/Siding' },
  { label: 'Security Systems', value: 'Security Systems' },
  { label: 'Solar', value: 'Solar' },
  { label: 'Stormwater Management', value: 'Stormwater Management' },
  { label: 'Tree Services', value: 'Tree Services' },
  { label: 'Water Damage Services', value: 'Restoration' },
  { label: 'Window Cleaning', value: 'Window Cleaning' },
  { label: 'Other', value: 'Other' },
];

export const stateList = [
  { label: 'Select a state...', value: '' },
  { label: 'Alabama', value: 'Alabama' },
  { label: 'Alaska', value: 'Alaska' },
  { label: 'Arizona', value: 'Arizona' },
  { label: 'Arkansas', value: 'Arkansas' },
  { label: 'California', value: 'California' },
  { label: 'Colorado', value: 'Colorado' },
  { label: 'Connecticut', value: 'Connecticut' },
  { label: 'Delaware', value: 'Delaware' },
  { label: 'Florida', value: 'Florida' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Hawaii', value: 'Hawaii' },
  { label: 'Idaho', value: 'Idaho' },
  { label: 'Illinois', value: 'Illinois' },
  { label: 'Indiana', value: 'Indiana' },
  { label: 'Iowa', value: 'Iowa' },
  { label: 'Kansas', value: 'Kansas' },
  { label: 'Kentucky', value: 'Kentucky' },
  { label: 'Louisiana', value: 'Louisiana' },
  { label: 'Maine', value: 'Maine' },
  { label: 'Maryland', value: 'Maryland' },
  { label: 'Massachusetts', value: 'Massachusetts' },
  { label: 'Michigan', value: 'Michigan' },
  { label: 'Minnesota', value: 'Minnesota' },
  { label: 'Mississippi', value: 'Mississippi' },
  { label: 'Missouri', value: 'Missouri' },
  { label: 'Montana', value: 'Montana' },
  { label: 'Nebraska', value: 'Nebraska' },
  { label: 'Nevada', value: 'Nevada' },
  { label: 'New Hampshire', value: 'New Hampshire' },
  { label: 'New Jersey', value: 'New Jersey' },
  { label: 'New Mexico', value: 'New Mexico' },
  { label: 'New York', value: 'New York' },
  { label: 'North Carolina', value: 'North Carolina' },
  { label: 'North Dakota', value: 'North Dakota' },
  { label: 'Ohio', value: 'Ohio' },
  { label: 'Oklahoma', value: 'Oklahoma' },
  { label: 'Oregon', value: 'Oregon' },
  { label: 'Pennsylvania', value: 'Pennsylvania' },
  { label: 'Rhode Island', value: 'Rhode Island' },
  { label: 'South Carolina', value: 'South Carolina' },
  { label: 'South Dakota', value: 'South Dakota' },
  { label: 'Tennessee', value: 'Tennessee' },
  { label: 'Texas', value: 'Texas' },
  { label: 'Utah', value: 'Utah' },
  { label: 'Vermont', value: 'Vermont' },
  { label: 'Virginia', value: 'Virginia' },
  { label: 'Washington', value: 'Washington' },
  { label: 'West Virginia', value: 'West Virginia' },
  { label: 'Wisconsin', value: 'Wisconsin' },
  { label: 'Wyoming', value: 'Wyoming' },
];

export const technicianOptions = [
  { label: '1 tech', value: '1' },
  { label: '2 techs', value: '2' },
  { label: '3 techs', value: '3' },
  { label: '4-9 techs', value: '9' },
  { label: '10-29 techs', value: '29' },
  { label: '30+ techs', value: '30' },
];

export const technicianOptionsDemo4 = [
  { label: '1 tech', value: '1' },
  { label: '2 techs', value: '2' },
  { label: '3-4 techs', value: '3' },
  { label: '5-9 techs', value: '5' },
  { label: '10-29 techs', value: '10' },
  { label: '30-49 techs', value: '30' },
  { label: '50+ techs', value: '50' },
];

export const staffCountOptions = [
  { label: '0', value: '0' },
  { label: '1 part time', value: '.5' },
  { label: '1', value: '1' },
  { label: '2 or more', value: '2' },
];

export const focusOptions = [
  { label: 'Residential', value: 'Residential' },
  { label: 'Commercial', value: 'Commercial' },
];

export const typeOfWorkOptions = [
  { label: 'Service and Replacement', value: 'Service & Replacement' },
  { label: 'Construction or Remodel', value: 'Construction or Remodel' },
];
